import { isThresholdXStaticInternal } from './type-guards.js';
import { mapIndicatorDataFrom } from './utils.js';
import { thresholdPlot } from './XYChartThresholdIndicators.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { ThresholdIndicator } from '../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { useGetThresholds } from '../../hooks/useGetThresholds.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { useHoveredThresholdState } from '../../store/selectors.js';

export const XYChartThresholdIndicators = () => {
  const { thresholds, none } = useGetThresholds();
  const { width, height } = useGridPlotSize();
  const axisIdToScales = useXYChartScales();
  const hoveredThresholdId = useHoveredThresholdState();
  const { axes } = useXYChartData();

  if (none) {
    return null;
  }

  return (
    <svg className={thresholdPlot}>
      {thresholds.map((threshold) => {
        // Skip thresholds whose bound axis is not present (e.g. toggled off via
        // series filtering). The guard covers both the X-bound (xAxisId) and
        // Y-bound (yAxisId) paths so a stale axis id never breaks the chart.
        const axisId = isThresholdXStaticInternal(threshold)
          ? threshold.xAxisId
          : threshold.yAxisId;

        if (!axes.find((axis) => axis.id === axisId)) {
          return undefined;
        }

        const data = mapIndicatorDataFrom({
          axisIdToScales,
          threshold,
          width,
          height,
        });

        return (
          <ThresholdIndicator
            key={`threshold-indicator-${threshold.id}`}
            data={data}
            color={threshold.color}
            strokeOnly={threshold.strokeOnly}
            isActive={hoveredThresholdId === threshold.id}
          />
        );
      })}
    </svg>
  );
};
